<template>
  <div class="panel granary-panel">
    <div class="chart-box">
      <div class="tab-box flex">
        <div
          v-for="(item, index) in typeList"
          :key="index"
          class="tab-item"
          :class="{ active: active === index }"
          @click="changeType(index)"
        >
          <span>{{ item }}</span>
        </div>
      </div>
      <div ref="chart" class="chart"></div>
    </div>
  </div>
</template>

<script>
import { loadChart } from "./charts/nccyData";
import { findPigTzAreaQsByType } from "@/api/granary";
import { timerMixin } from "@/util/mixin/timerMixin";
export default {
  mixins: [timerMixin],
  data() {
    return {
      typeList: ["开证量", "生猪数量", "肉品重量"],
      active: 0
    };
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
    this.getData();
    this.startTimer();
  },
  methods: {
    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, false);
    },
    changeType(index, clearT = true) {
      this.active = index;
      this.getData();
      if (clearT) {
        this.startTimer();
      }
    },
    getData() {
      if (!this.chart) {
        this.chart = this.$echarts.init(this.$refs.chart);
      }

      findPigTzAreaQsByType({ type: this.active + 1 }).then(res => {
        console.log("res", res);
        if (res.data) {
          let yearlist = [];
          let bflist = [];
          res.data.forEach(ele => {
            let str = ele.year + "." + ele.month;
            yearlist.push(str);
            bflist.push(ele.num);
          });
          yearlist = yearlist.reverse();
          bflist = bflist.reverse();
          const bfData = [bflist];
          let unit = "";
          if (this.active === 0) {
            unit = "份";
          } else if (this.active === 1) {
            unit = "头";
          } else {
            unit = "吨";
          }
          loadChart(
            this.chart,
            yearlist,
            bfData,
            this.typeList[this.active],
            unit
          );
        }
      });
    }
    // getData() {
    //   this.chart = this.$echarts.init(this.$refs.chart);
    //   const yearlist = ["2021.07", "2021.08", "2021.09", "2021.10"];
    //   let unit = "";
    //   let bfData = [];
    //   let max = 100;
    //   let min = 0;
    //   if (this.active === 0) {
    //     const bflist = [160, 270, 220, 390];
    //     // const resultArr = ["总产值", "种植", "畜牧", "水产"];
    //     bfData = [bflist];
    //     unit = "份";
    //     max = 400;
    //   } else if (this.active === 1) {
    //     const bflist = [1850875, 1876875, 1906875, 1936875];
    //     bfData = [bflist];
    //     unit = "头";
    //     min = 1830000;
    //     max = 1940000;
    //   } else {
    //     const bflist = [322393, 342393, 362393, 392393];
    //     bfData = [bflist];
    //     unit = "吨";
    //     min = 310000;
    //     max = 393000;
    //   }
    //   loadChart(
    //     this.chart,
    //     yearlist,
    //     bfData,
    //     this.typeList[this.active],
    //     unit,
    //     max,
    //     min
    //   );
    // }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  width 100%
  .chart-box
    width 100%
    height 100%
    position relative
    .tab-box
      position absolute
      top 10px
      right 4%
      z-index 999
      .tab-item
        color #fff
        font-size 10px
        padding-left 13px
        margin-right 20px
        position relative
        cursor pointer
        &:before
          content ' '
          // width 6px
          // height 6px
          width 12px
          height 12px
          border-radius 50%
          background #fff
          position absolute
          left 0
          top 50%
          transform translateY(-50%)
      .active
        color #0e9cff
        &:before
          background #0e9cff
</style>
